import React from 'react';
import { connect } from 'react-redux';
import { AlTemplateModRow } from 'PatientCareCenter/Note/AL/Templates';
import styles from './Common.module.css';


class AlTemplateMod extends React.Component {

    render() {
        if (this.props.activities.length > 0) {
            return (
                <div className={styles.section_wrapper}>
                    <div className={styles.header_row}>Modalities</div>

                    {Object.keys(this.props.activities)
                        .map(key => {
                            const result = this.props.activities[key];
                            return (
                                <AlTemplateModRow key={result.XLTMPMDNO} id={result.XLTMPMDNO} />
                            )
                        })
                    }
                </div>
            );
        } else {
            return (<span />);
        }
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;

    return {
        activities: state.entities.notes.MLTMPMOD ?
            Object.keys(state.entities.notes.MLTMPMOD)
                .filter(key => {
                    return (state.entities.notes.MLTMPMOD[key].NoteId === noteId)
                })
                .sort((a, b) => state.entities.notes.MLTMPMOD[a].XLTMPMDORDER - state.entities.notes.MLTMPMOD[b].XLTMPMDORDER)
                .map(key => state.entities.notes.MLTMPMOD[key]) : [],
    };
}

const connectedAlTemplateMod = connect(mapStateToProps)(AlTemplateMod);
export { connectedAlTemplateMod as AlTemplateMod };

